import { render, staticRenderFns } from "./AddPerson.vue?vue&type=template&id=3046092f&scoped=true"
import script from "./AddPerson.vue?vue&type=script&lang=js"
export * from "./AddPerson.vue?vue&type=script&lang=js"
import style0 from "./AddPerson.vue?vue&type=style&index=0&id=3046092f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046092f",
  null
  
)

export default component.exports